import { calculateMultiSubscriptionTotals } from '@fd/common/biz/pricing';
import usePaymentDetails from '../store/paymentDetailsStore';
import { useCartStore } from '../store/cartStore';

export function useTotals() {
  const { items } = useCartStore();
  const { coupon } = usePaymentDetails();
  return calculateMultiSubscriptionTotals({
    mobile: items.find((item) => item.type === 'mobile')?.quantity ?? 0,
    datacenter: items.find((item) => item.type === 'datacenter')?.quantity ?? 0,
    residential: items.find((item) => item.type === 'residential')?.quantity ?? 0,
    discountPercentage:
      coupon?.type === 'percentage' ? coupon.discountValue : undefined,
    discountFixed:
      coupon?.type === 'fixed_amount' ? coupon.discountValue : undefined,
  });
}
